import React from 'react'
import PropTypes from 'prop-types'
import { cx } from '@emotion/css'
import ButtonLink from '../../ButtonLink'
import styles, { footerSize } from './styles'

const ModalFooter = ({ size, children, onCancel, className }) => (
  <div className={cx(styles.footer, className, footerSize(size))}>
    <div className={styles.actions}>{children}</div>

    {Boolean(onCancel) && <ButtonLink theme="light" label="Cancel" onClick={onCancel} />}
  </div>
)

ModalFooter.propTypes = {
  size: PropTypes.oneOf(['', 'default', 'small', 'medium', 'large']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  onCancel: PropTypes.func,
  className: PropTypes.string,
}

ModalFooter.defaultProps = {
  size: 'default',
}

export default ModalFooter
